import { createStore } from 'zustand'
import { devtools } from 'zustand/middleware'
import { Store, WithoutFunctions } from './type'
import { bannerSlice } from './banner/slice'
import { configurationSlice } from './configuration/slice'
import { authSlice } from './auth/slice'
import { navigationSlice } from './navigation/slice'
import { emailSlice } from './email/slice'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createPBStore = (initialProps: Partial<WithoutFunctions<Store>>) =>
  createStore(
    devtools<Store>(
      (...a) => ({
        ...configurationSlice(...a),
        ...authSlice(...a),
        ...bannerSlice(...a),
        ...navigationSlice(...a),
        ...emailSlice(...a),
        ...initialProps,
      }),
      {
        name: 'bst',
        enabled:
          typeof window === 'object' && process.env.NODE_ENV === 'development',
      },
    ),
  )
